import axios from 'axios';

export const getPolicies = async () => {
  const response = await axios.get(`/admin-config/policies`);

  response.data = response.data.map((policy) => ({
    ...policy,
    specializations: policy.specializations.map((specialization) => specialization.specialization)
  }));

  return response;
};

export const createPolicy = async (policy) => {
  const response = await axios.post(`/admin-config/policies`, policy);

  response.data = {
    ...response.data,
    specializations: response.data.specializations.map(
      (specialization) => specialization.specialization
    )
  };

  return response;
};

export const updatePolicy = async (policy) => {
  const response = await axios.put(`/admin-config/policies/${policy.id}`, policy);

  response.data = {
    ...response.data,
    specializations: response.data.specializations.map(
      (specialization) => specialization.specialization
    )
  };

  return response;
};
